module.exports = __webpack_public_path__ + "img/bg-bestprice.13407365.jpg";